import { render, staticRenderFns } from "./tabGroup.vue?vue&type=template&id=0895a71a&scoped=true"
import script from "./tabGroup.vue?vue&type=script&lang=js"
export * from "./tabGroup.vue?vue&type=script&lang=js"
import style0 from "./tabGroup.vue?vue&type=style&index=0&id=0895a71a&prod&lang=scss&scoped=true"
import style1 from "./tabGroup.vue?vue&type=style&index=1&id=0895a71a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0895a71a",
  null
  
)

export default component.exports